module.exports = __webpack_public_path__ + "img/logow.db975645.png";